import React from "react";
import { motion } from "framer-motion";
import { Droplets, Wrench, ShieldAlert, Flame, Thermometer, Hammer, ChevronRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { scrollToId } from "../lib/api";

const ICONS = { Droplets, Wrench, ShieldAlert, Flame, Thermometer, Hammer };

export default function Services() {
  return (
    <section id="szolgaltatasok" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-widest font-bold text-sky-600 bg-sky-50 px-3 py-1 rounded-full inline-block mb-4 border border-sky-100">
            Amit vállalok
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Víz- és fűtésszerelés, <span className="text-sky-600">egy kézből.</span>
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            A legkisebb csöpögéstől a teljes fűtésrendszer kiépítéséig – precízen, tisztán és korrekt hozzáállással.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group relative rounded-2xl border border-slate-200 bg-gradient-to-br from-sky-50/40 to-white p-7 hover:border-sky-300 hover:shadow-xl hover:shadow-sky-100 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-sky-600 flex items-center justify-center mb-5 shadow-lg shadow-sky-600/20 group-hover:scale-110 group-hover:-rotate-6 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-display text-xl font-bold text-slate-900 mb-2">{s.title}</h3>
                <p className="text-slate-600 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            onClick={() => scrollToId("arajanlat")}
            className="group inline-flex items-center gap-2 text-sky-700 font-bold hover:gap-3 transition-all"
          >
            Nem találja a problémáját? Kérdezzen bátran
            <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
